<template>
  <div data-skeleton-wrapper="true" :id="`${generateHashComputed}`">
    <div :class="componentManager" v-if="visibilityStatus">
      <slot name="component"></slot>
    </div>
    <div :class="loadingManager">
      <slot name="loading"></slot>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import {mapGetters} from "vuex";

export default defineComponent({
  name: "SkeletonWrapper",
  data() {
    return {
      status: false,
      visibilityStatus: false
    }
  },
  computed: {
    ...mapGetters({
      skeletonComponentStatus: 'Skeleton/getSkeletonComponentStatus'
    }),
    generateHashComputed() {
      return `skeleton-token-${generateHash()}`
    },
    loadingManager() {
      return !this.status ? '' : 'd-none'
    },
    componentManager() {
      return this.status ? '' : 'd-none'
    }
  },
  methods: {
    visibilityChecker() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.visibilityStatus = true
          }
        });
      });
      observer.observe(this.$parent.$el);
    }
  },
  mounted() {
    this.visibilityChecker()
  },
  watch: {
    skeletonComponentStatus: {
      async handler(oldValue, newValue) {
        this.status = this.skeletonComponentStatus[this.generateHashComputed]
      },
      deep: true
    }
  },
})
</script>

<style scoped>

</style>